import { createContext } from 'react'

// Opt shared forms into Piazza without changing their existing consumers or validation.
export const PiazzaInputContext = createContext(false)
